import { ThemeProvider } from '@emotion/react';
import type { MicrositeConfig } from '~/model';
import styled from '@emotion/styled';
import { MicrositeStateProvider } from '~/hooks/useMicrositeState';
import './microsite.css';
import { MicrositePuckProvider } from '~/hooks/useMicrositePuck';
import { MicrositePortalProvider } from '~/components/MicrositePortal';
import { LoadPriorityProvider } from '~/hooks/useLoadPriority';
import type { PuckData } from '~/editor/config';

const Wrapper = styled.div`
	font-family: ${({ theme }) => theme.font.family.stack};
`;

export default function MicrositeWrapper({
	children,
	config,
	data,
	zoom,
}: {
	children: React.ReactNode;
	config: MicrositeConfig;
	data: PuckData;
	zoom?: number;
}) {
	return (
		<MicrositePortalProvider>
			<LoadPriorityProvider>
				<MicrositeStateProvider>
					<MicrositePuckProvider data={data}>
						<ThemeProvider
							theme={{
								...config.theme,
								zoom,
							}}
						>
							<Wrapper itemType="https://schema.org/Offer" itemScope>
								{children}
							</Wrapper>
						</ThemeProvider>
					</MicrositePuckProvider>
				</MicrositeStateProvider>
			</LoadPriorityProvider>
		</MicrositePortalProvider>
	);
}
